var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-create-user-for-employee" },
    [
      _vm.record.fullName
        ? _c(
            "b-modal",
            {
              attrs: {
                id: _vm.id,
                size: "custom-size",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
              },
              on: {
                close: function ($event) {
                  _vm.localActive = false
                },
              },
              model: {
                value: _vm.localActive,
                callback: function ($$v) {
                  _vm.localActive = $$v
                },
                expression: "localActive",
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "m-create-user-for-employee-close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      _vm.localActive = false
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _vm.modalTitle
                ? _c(
                    "div",
                    { staticClass: "m-create-user-for-employee-title" },
                    [_vm._v(" " + _vm._s(_vm.modalTitle) + " ")]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "m-create-user-for-employee-fullname" },
                [_vm._v(_vm._s(_vm.record.fullName.value))]
              ),
              _c("c-input", {
                staticClass: "m-create-user-for-employee-input",
                attrs: {
                  "floating-label": "Логин",
                  "max-length": 20,
                  required: _vm.isSubmitted && _vm.loginError,
                  "required-message": _vm.isSubmitted && _vm.loginError,
                  "required-mark": true,
                  clearable: true,
                },
                model: {
                  value: _vm.login,
                  callback: function ($$v) {
                    _vm.login = $$v
                  },
                  expression: "login",
                },
              }),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-12 col-xl-6" },
                  [
                    _c("c-input", {
                      staticClass: "m-create-user-for-employee-input",
                      attrs: {
                        type: "password",
                        "floating-label": "Пароль",
                        "max-length": 16,
                        required: _vm.isSubmitted && _vm.passwordError,
                        "required-message":
                          _vm.isSubmitted && _vm.passwordError,
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-12 col-xl-6" },
                  [
                    _c("c-input", {
                      staticClass: "m-create-user-for-employee-input",
                      attrs: {
                        type: "password",
                        "floating-label": "Подтверждение пароля",
                        "max-length": 16,
                        required:
                          _vm.isSubmitted && _vm.passwordConfirmationError,
                        "required-message":
                          _vm.isSubmitted && _vm.passwordConfirmationError,
                      },
                      model: {
                        value: _vm.passwordConfirmation,
                        callback: function ($$v) {
                          _vm.passwordConfirmation = $$v
                        },
                        expression: "passwordConfirmation",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "col col-12 col-md-12 col-xl-12" }, [
                  _c("p", { staticClass: "message" }, [
                    _vm._v(
                      "Если поле «пароль» не заполнено, пароль будет сгенерирован автоматически"
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-12 col-xl-6" },
                  [
                    _c("c-input", {
                      staticClass: "m-create-user-for-employee-input",
                      attrs: {
                        "floating-label": "Email сотрудника",
                        required: _vm.isSubmitted && _vm.emailError,
                        "required-message": _vm.isSubmitted && _vm.emailError,
                        "required-mark": true,
                        clearable: true,
                        "max-length": 128,
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-12 col-xl-6" },
                  [
                    _c("c-input", {
                      staticClass: "m-create-user-for-employee-input",
                      attrs: {
                        type: "select",
                        "floating-label": "Роль",
                        multiple: true,
                        searchable: true,
                        items: _vm.collections.roles,
                        required: _vm.isSubmitted && _vm.roleError,
                        "required-message": _vm.isSubmitted && _vm.roleError,
                        "required-condition": _vm.isSubmitted && _vm.roleError,
                        "required-mark": true,
                      },
                      model: {
                        value: _vm.role,
                        callback: function ($$v) {
                          _vm.role = $$v
                        },
                        expression: "role",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "m-create-user-for-employee-buttons" },
                [
                  _c("c-button", {
                    attrs: { color: "white", label: "Отменить" },
                    on: { click: _vm.closeModal },
                  }),
                  _c("c-button", {
                    attrs: {
                      color: "primary",
                      label: "Сохранить",
                      disabled: _vm.isPending,
                    },
                    on: { click: _vm.createUser },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.record.fullName
        ? _c(
            "b-modal",
            {
              attrs: {
                id: "create-user-employee-modal-success",
                size: "custom-size",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
              },
              model: {
                value: _vm.localActiveSuccessModal,
                callback: function ($$v) {
                  _vm.localActiveSuccessModal = $$v
                },
                expression: "localActiveSuccessModal",
              },
            },
            [
              _c("div", { staticClass: "create-user-success-modal" }, [
                _c(
                  "svg",
                  {
                    staticClass: "create-user-success-modal-close",
                    attrs: {
                      width: "15",
                      height: "16",
                      viewBox: "0 0 15 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                    on: {
                      click: function ($event) {
                        _vm.localActiveSuccessModal = false
                      },
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                        fill: "#8E9CBB",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                        fill: "#8E9CBB",
                      },
                    }),
                  ]
                ),
                _c("h2", { staticClass: "create-user-success-modal-title" }, [
                  _vm._v("Пользователь успешно добавлен"),
                ]),
                _c(
                  "div",
                  { staticClass: "create-user-success-modal-description" },
                  [
                    _vm._v(" Для сотрудника "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "create-user-success-modal-description-bold",
                      },
                      [_vm._v(_vm._s(_vm.record.fullName.value))]
                    ),
                    _vm._v(" создан пользователь. "),
                  ]
                ),
                _c("div", { staticClass: "create-user-success-modal-item" }, [
                  _c(
                    "div",
                    { staticClass: "create-user-success-modal-item-name" },
                    [_vm._v("Логин")]
                  ),
                  _c(
                    "div",
                    { staticClass: "create-user-success-modal-item-value" },
                    [_vm._v(_vm._s(_vm.user.username))]
                  ),
                ]),
                _c("div", { staticClass: "create-user-success-modal-item" }, [
                  _c(
                    "div",
                    { staticClass: "create-user-success-modal-item-name" },
                    [_vm._v("Пароль")]
                  ),
                  _c(
                    "div",
                    { staticClass: "create-user-success-modal-item-value" },
                    [
                      _c("copy-field", {
                        attrs: {
                          text: _vm.user.password,
                          editable: true,
                          password: true,
                          success: "Пароль скопирован в буфер обмена",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass:
                      "c-button close-popover c-button-ok create-user-success-modal-close-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.localActiveSuccessModal = false
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "c-button-label" }, [
                      _vm._v("Закрыть"),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }